<template>
  <div class="full">

    <div class="content">
      <p class="title">
        <span style="color: #ff6c1a">完善</span>
        个人信息
      </p>
      <van-form @submit="onSubmit">
        <div class="item">
          <p class="item-title">姓名</p>
          <van-field v-model="yzxm" placeholder="" :rules="[{ required: true, message: '请输入用户名' }]" />
        </div>
        <div class="item">
          <p class="item-title">身份证号码</p>
          <van-field v-model="zjhm" placeholder="" :rules="[{ required: true, message: '请输入身份证号码' }, {
            pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确的身份证号',
          }]" />
        </div>
        <div class="item">
          <p class="item-title">电话号码</p>
          <van-field v-model="lxdh" placeholder="" :rules="[{ required: true, message: '请输入电话号码' }, {
            pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号',
          }]" />
        </div>
        <van-button round block class="btn" @click="handlerLogin" native-type="submit">确定
        </van-button>
      </van-form>
    </div>

  </div>
</template>

<script>

import api from '@/api/login.js'
export default {
  name: '',
  components: {

  },
  data() {
    return {
      yzxm: "",
      lxdh: "",
      zjhm: '',
      openId: "",
      wyqyId: "",
      information: {},
    }
  },
  created() {
  },

  mounted() {
  },
  methods: {

    //获取用户信息
    getUserinfo() {
      let openId = sessionStorage.getItem('openId')
      api.info({ openId: openId }).then(res => {
        if (res.data.code == 200) {

          sessionStorage.removeItem('wyqy')
          sessionStorage.setItem('wyqy', res.data.data.yzfwVo[0].wyqyId)
          this.wyqyId = res.data.data.yzfwVo[0].wyqyId
        } else {
          this.$toast.fail({
            message: '获取信息失败，请重新获取',
          })
        }
      }).catch(err => {
        this.$toast.fail({
          message: err,
        })
      })
    },
    // 注册提交按钮
    onSubmit(val) {
      sessionStorage.removeItem("flag");
      if (val) {
        let params = {
          lxdh: this.lxdh,
          yzxm: this.yzxm,
          zjhm: this.zjhm,
          openId: sessionStorage.getItem('openId')
        }

        api.register(params).then(res => {
          if (res.data.code == 200) {
            this.$toast.success({
              message: '注册成功！',
            })

            // this.$router.push('/')
            location.href = '/'
            if (res.data.data == 1) {
              // this.$router.push('/')
              location.href = '/'

            }
          } else if (res.data.msg == '用户已注册！') {
            this.$toast.success({
              message: res.data.msg,
            })
            location.href = '/'
          } else {
            this.$toast.success({
              message: res.data.msg,
            })

          }

        }).catch(err => {
          this.$toast.fail({
            message: err,
          })

        })
      }

    },


    onClickLeft() {

      window.history.go(-1)
    },
    handlerLogin() {
      this.onSubmit()
    }

  }
}
</script>

<style lang="less" scoped>
.full {
  height: 100%;
  background-color: #fff;

  .content {
    margin: 0 20px 20px 20px;

    .title {
      width: 100%;
      height: 28px;
      font-size: 20px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      line-height: 23px;
      margin-bottom: 30px;
    }

    .item {
      width: 100%;
      height: 70px;
      border-radius: 0px 0px 0px 0px;
      border-bottom: 1px solid #eee;
      margin-bottom: 20px;

      .item-title {
        width: 100%;
        height: 20px;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 550;
        color: #6b6a6a;
        line-height: 16px;
      }
    }

    .btn {
      width: 335px;
      height: 46px;
      color: #fff;
      text-align: center;
      line-height: 46px;
      font-size: 16px;
      background: #ff6c1a;
      border-radius: 23px 23px 23px 23px;
      opacity: 1;
    }
  }
}

/deep/ .van-field {
  padding: 0;
}

/deep/ .van-field__control {
  font-size: 16px;
}
</style>
